export default __webpack_public_path__ + "static/media/gunpig_thumbnail.bdbccf43.jpg";